// extracted by mini-css-extract-plugin
export default {"container":"EstimateNotes_container__YWNGx","listNote":"EstimateNotes_listNote__OIMHI","noDataAvailable":"EstimateNotes_noDataAvailable__7gLYR"};